<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户维护</el-breadcrumb-item>
      <el-breadcrumb-item>客户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="10">
          <el-input
            placeholder="请输入查询内容"
            v-model="queryInfo.query"
            class="input-with-select"
            clearable
            style="width:300px "
            @clear="getguestList"
            @change="getguestList"
          >
            <el-button slot="append" icon="el-icon-search" @click="getguestList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="print_query">打印报表</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="el_row_two">
        <el-col :span="24">
          <el-table :data="guestList" style="width: 100%" border stripe id="query_print" name="baobiao">
                   <el-table-column prop="uid" label=" 序号" width="80"></el-table-column>
            <el-table-column prop="guest_bianhao" label=" 编号" width="120"></el-table-column>
            <el-table-column prop="guest_name" label="客户名称"></el-table-column>
            <el-table-column prop="guest_mob" label="手机"></el-table-column>
            <el-table-column prop="guest_addr" label="地址"></el-table-column>
          
            <el-table-column prop="add_time" label="加入时间"></el-table-column>
             
          </el-table>
        </el-col>
      </el-row>
      <!-- 分页 -->
    </el-card>
  </div>
</template>
<script>
import printJS from 'print-js'
export default {
  data() {
    return {
     
      // 获取用户列表参数
      queryInfo: {
        C_type: 'get_list',
        C_table_name: 'guest_list',
        query: '',
        pageNum: 1,
        pageSize: 10000
      },
      guestList: [],
      //  recordCount: 0,
      total: 0 
    }
  },
  created() {
    this.getguestList();
  },
  methods: {
    print_query() {
      printJS({ printable: 'query_print', type: 'html', scanStyles: false, css: ['https://qiniu.smartpilot.cn/myreport.css'], style: '' })
    },
    async getguestList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      });
      // console.log(JSON.parse(res.data))
      this.guestList = JSON.parse(res.data)[0].dataList;

      if (!this.guestList) return;
      this.guestList.forEach(function(item) {
        item.yong_flag = item.yong_flag === 1;
      });

      this.total = JSON.parse(res.data)[0].total;

      // console.log(this.total)
    }
  }
}
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important ;
  background-color: #f2f6fc;
}
.el_row_two {
  margin-top: 30px;
}
</style>
